import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { LegalPage } from './LegalPage';
import { PRIVACY } from './legal-content';

export default function PrivacyPolicy() {
    return (
        <LegalPage
            icon={Shield}
            content={PRIVACY}
            extraFooter={
                <>
                    <Link to="/cookies" className="text-[hsl(var(--accent))] underline">Cookie Policy</Link>
                    {' · '}
                    <Link to="/terms" className="text-[hsl(var(--accent))] underline">Terms</Link>
                </>
            }
        />
    );
}
